var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 25.8333V16.5",
    stroke: "#7265AD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1108 19.1667L16.0002 16.2773L18.8895 19.1667",
    stroke: "#7265AD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3331 25.8334H24.7464C27.3171 25.8334 29.4131 23.7374 29.4131 21.1667C29.4131 18.5961 27.3171 16.5001 24.7464 16.5001H24.1664V15.1667C24.1664 10.7534 20.5798 7.16675 16.1664 7.16675C12.1971 7.16675 8.90643 10.0707 8.28243 13.8641C5.11309 14.0254 2.58643 16.6241 2.58643 19.8334C2.58643 23.1467 5.27309 25.8334 8.58643 25.8334H10.6664",
    stroke: "#7265AD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b39d95ac45e05847bf80a15844acfda8.svg";
export { ForwardRef as ReactComponent };